import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=129842fe"
import script from "./Paper.vue?vue&type=script&lang=js"
export * from "./Paper.vue?vue&type=script&lang=js"
import style0 from "./Paper.vue?vue&type=style&index=0&id=129842fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports